import { render, staticRenderFns } from "./Monthlyprofit.vue?vue&type=template&id=23bcfabf&scoped=true&"
import script from "./Monthlyprofit.vue?vue&type=script&lang=js&"
export * from "./Monthlyprofit.vue?vue&type=script&lang=js&"
import style0 from "./Monthlyprofit.vue?vue&type=style&index=0&id=23bcfabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bcfabf",
  null
  
)

export default component.exports